import { Component } from '@theme/component';

class CartTermsGate extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.updatedCallback();
  }

  /**
   * Re-syncs the checkout button's disabled state with the checkbox's checked state.
   * Runs after every morph, since morph.js only preserves checked/disabled across
   * re-renders for <input> elements, not the checkout <button>.
   */
  updatedCallback() {
    super.updatedCallback();
    const { checkoutButton, termsCheckbox } = this.refs;
    if (!checkoutButton || !termsCheckbox) return;
    checkoutButton.disabled = !termsCheckbox.checked;
  }

  handleChange(event) {
    const { checkoutButton } = this.refs;
    if (checkoutButton) checkoutButton.disabled = !event.target.checked;
  }
}

if (!customElements.get('cart-terms-gate')) {
  customElements.define('cart-terms-gate', CartTermsGate);
}
